export default __webpack_public_path__ + "static/media/img1.1edff0d4.png";